import React, { useState, useRef } from 'react'
import { FiSearch } from 'react-icons/fi'
import api from '../../utils/api'
import Spinner from '../Spinner'
import { DateRange } from "react-date-range"
import "react-date-range/dist/styles.css"
import "react-date-range/dist/theme/default.css"
import { DateRangePickerDropdown } from '../DashboardOverviewFilter'


const HarvestRequestFilter = ({
  placeholder = "Search...",
  suggestions = [],
  onSearch,
  searchValue,
  setSearchValue,
  states,
  setStates,
  handleChange,
  dateRange,
  setDateRange
}) => {
  // const [searchValue, setSearchValue] = useState("")
  const [showSuggestions, setShowSuggestions] = useState(false)
  const inputRef = useRef(null)

  // Filter suggestions based on input
  const filteredSuggestions = (suggestions || []).filter(s =>
    typeof s === 'string' && s.toLowerCase().includes((searchValue || "").toLowerCase())
  )

  return (
    <div className='flex flex-col lg:flex-row lg:items-center lg:justify-between lg:gap-14 gap-5 w-full'>
      {/* SEARCH */}
      <div className='flex flex-row gap-2'>
        <div className='w-full relative'>
          <input
            type="text"
            placeholder={placeholder}
            className="w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-9 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 100)}
            ref={inputRef}
          />
          <FiSearch size={20} className='absolute left-2 top-1/2 -translate-y-1/2 text-black/70 dark:text-white/70' />
          {showSuggestions && filteredSuggestions.length > 0 && (
            <div className="absolute left-0 right-0 mt-1 bg-white dark:bg-secondaryDark rounded-md shadow-xl z-50 max-h-60 overflow-y-auto">
              {filteredSuggestions.map((suggestion, idx) => (
                <div
                  key={idx}
                  className="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-secondaryDark dark:hover:bg-dark text-black dark:text-white text-sm"
                  onMouseDown={() => {
                    setSearchValue(suggestion)
                    setShowSuggestions(false)
                    inputRef.current?.blur()
                    if (onSearch) onSearch(suggestion)
                  }}
                >
                  {suggestion}
                </div>
              ))}
            </div>
          )}
        </div>
        <button
          // disabled={searchValue?.trim()?.length === 0}
          onClick={() => onSearch && onSearch(searchValue)}
          className='bg-yellowcolor hover:bg-yellowcolor/80 text-black px-6 flex items-center justify-center py-2 rounded-md'>
          Search
        </button>
      </div>

      <div className='flex flex-col sm:flex-row md:flex-row gap-2 sm:items-center md:items-center'>
        <div className='w-full md:w-1/2'>
          <select
            name="status"
            onChange={handleChange}
            value={states.status}
            className="py-3 capitalize px-4 pe-9 block w-full border-gray-200 rounded-lg text-sm focus:border-yellowcolor focus:ring-yellowcolor disabled:opacity-50 disabled:pointer-events-none bg-white dark:bg-dark border dark:border-border-dark dark:text-white">
            <option value="">All Status</option>
            {["pending", "responded", "published", "fulfilled", "rejected"].map((item, index) => (
              <option className='capitalize' key={index} value={item}>{item.charAt(0).toUpperCase() + item.slice(1)}</option>
            ))}
          </select>
        </div>

        <div className='w-full md:w-1/2'>
          <select
            onChange={handleChange}
            name="request_type"
            value={states.request_type}
            className="py-3 px-4 capitalize pe-9 block w-full border-gray-200 rounded-lg text-sm focus:border-yellowcolor focus:ring-yellowcolor disabled:opacity-50 disabled:pointer-events-none bg-white dark:bg-dark border dark:border-border-dark dark:text-white">
            <option value="">All Request Types</option>
            {["outgoing", "incoming"].map((item, index) => (
              <option className="capitalize" key={index} value={item}>{item.charAt(0).toUpperCase() + item.slice(1)}</option>
            ))}
          </select>
        </div>


        <div className='w-full md:w-1/2 flex items-end justify-end'>
          <DateRangePickerDropdown range={dateRange} onChange={setDateRange} />
        </div>


      </div>
    </div>
  )
}


export default HarvestRequestFilter
